import { render, staticRenderFns } from "./AppStorePage.vue?vue&type=template&id=2df4b2ac&scoped=true"
import script from "./AppStorePage.vue?vue&type=script&lang=js"
export * from "./AppStorePage.vue?vue&type=script&lang=js"
import style0 from "./AppStorePage.vue?vue&type=style&index=0&id=2df4b2ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df4b2ac",
  null
  
)

export default component.exports